
import { LucideIcon } from "lucide-react";
import { ThemeToggle } from "@/components/theme/ThemeToggle";
import FigmaExportButton from "@/components/figma/FigmaExportButton";

interface PageHeaderProps {
  title: string;
  icon: LucideIcon;
  iconColor?: string;
  showThemeToggle?: boolean;
  showFigmaExport?: boolean;
}

const PageHeader = ({ 
  title, 
  icon: Icon, 
  iconColor = "text-pink-500", 
  showThemeToggle = true,
  showFigmaExport = true
}: PageHeaderProps) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center">
        <Icon className={`w-6 h-6 ${iconColor} mr-2`} />
        <h1 className="text-2xl font-bold text-foreground">{title}</h1>
      </div>
      
      {(showThemeToggle || showFigmaExport) && (
        <div className="flex items-center gap-2">
          {showFigmaExport && <FigmaExportButton />}
          {showThemeToggle && <ThemeToggle variant="button" />}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
